import React, { Component } from "react";
import { API_ROOT_URL } from "../../config";
import {constants} from '../../Constants';
import moment from "moment";
import "./modal.css";
import { cnslrHistoryConst } from "../../helpers/ConstantID";

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }
  componentDidMount() {
    const token = JSON.parse(localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };
    return fetch(`${API_ROOT_URL}/sessions/?ordering=-appointment__slot__date_time&service_type_id=${this.props.service_type_id}`, requestOptions)
      .then(response => {
        return response.json();
      })
      .then(res => {
        this.setState({ data: res });
      });
  }
  onClose = e => {
    this.props.onClose && this.props.onClose(e);
  };
  render() {
    const {whitelabel} = this.props;
    const sessions = this.state.data;
    if (!this.props.showModal) {
      return null;
    }
    return (
      <div className="modal-react zIndex1" id="modal">
        <p className="mx-auto text-center card-title pt-2">Your previous sessions</p>
        <div className="content">
          {sessions.length > 0 ? (
            <table className="table borderless table-responsive w-100 d-block d-md-table">
              <tbody className="text-center tableBody">
                <tr>
                  <th>{whitelabel && whitelabel[0] ? whitelabel[0].producer_role : constants.COUNSELLOR}</th>
                  <th>Date/Time of Session</th>
                </tr>
                {sessions.map((v, i) => {
                  return (
                    <tr key={i} className="table-text">
                      <td>{v.full_name}</td>
                      <td className="overflow-handling">
                        {" "}
                        {moment(v.date_time)
                          .format("ddd DD MMM YYYY hh:mm:ss A")
                          .toLocaleString("en-US", {
                            hour: "numeric",
                            hour12: true
                          })}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div>No past sessions</div>
          )}
        </div>
        <div className="actions">
          <button className="toggle-button" id={cnslrHistoryConst.sh_pt_histroy_close} onClick={this.onClose}>
            Close
          </button>
        </div>
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.js